import React from 'react';
import { SkeletonText } from 'carbon-components-react';

export interface PricingSummarySkeletonLineItem {
  label: string;
  isHighlighted?: boolean;
  /** Static amount text (e.g. "Included"); omit to show a skeleton in the amount cell. */
  amount?: string;
}

interface PricingSummarySkeletonProps {
  lineItems: PricingSummarySkeletonLineItem[];
  totalLabel: string;
  showHeader?: boolean;
  variant?: 'default' | 'payment';
}

const AMOUNT_SKELETON = (
  <div className="pricing-summary-skeleton__amount-wrap">
    <SkeletonText width="100%" />
  </div>
);

const PricingSummarySkeleton: React.FC<PricingSummarySkeletonProps> = ({
  lineItems,
  totalLabel,
  showHeader = false,
  variant = 'default'
}) => {
  const tableClass =
    variant === 'payment'
      ? 'pricing-summary pricing-summary--payment'
      : 'pricing-summary pricing-summary--price';

  return (
    <table className={tableClass} aria-busy="true" aria-label="Loading pricing">
      {showHeader && (
        <thead>
          <tr className="pricing-summary__row--total">
            <th className="pricing-summary__cell">Description</th>
            <th className="pricing-summary__cell--amount">Amount</th>
          </tr>
        </thead>
      )}
      <tbody>
        {lineItems.map((item, index) => (
          <tr key={index} className="pricing-summary__row">
            <td
              className={
                item.isHighlighted
                  ? 'pricing-summary__cell--highlighted'
                  : 'pricing-summary__cell'
              }
            >
              {item.label}
            </td>
            <td className="pricing-summary__cell--amount">
              {item.amount ?? AMOUNT_SKELETON}
            </td>
          </tr>
        ))}
        <tr
          className="pricing-summary__row--total"
          style={lineItems.length === 0 ? { borderTop: 'none' } : undefined}
        >
          <td className="pricing-summary__cell">{totalLabel}</td>
          <td className="pricing-summary__cell--total-amount">
            {AMOUNT_SKELETON}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PricingSummarySkeleton;
